import { storePrefixPath } from '@/lib/namedRoutes'
import { storeRoutes } from '@/lib/routes/store'

/** Pills in the expanded shop header, in display order. */
export const storeNavigation = [
    { label: 'Explore', href: storeRoutes.explore() },
    { label: 'Visits', href: storeRoutes.visits() },
    { label: 'Medications', href: storeRoutes.medications() },
    { label: 'Labs', href: storeRoutes.labs() },
    { label: 'Specialists', href: storeRoutes.specialists() },
] as const

/** True for a store category URL that should keep the expanded header. Home is handled separately. */
export function isStoreNavigationDestination(pathname: string): boolean {
    return storeNavigation.some((item) => item.href !== storeRoutes.explore() && pathname === item.href)
}

/** Which expanded-header pill matches the current URL. Explore also matches `/store`. */
export function isActiveStoreTab(pathname: string, href: string): boolean {
    if (href === storeRoutes.explore()) {
        return pathname === storeRoutes.explore() || pathname === storePrefixPath
    }

    return pathname === href
}
